// extracted by mini-css-extract-plugin
export default {"wrapper":"CourtCaseForm_wrapper__a8Exr"};